import { CreateVesting } from "../../components/vesting/create-vesting";
import { useAdmin } from "../../hooks/use-admin";
import TransferAdmin from "components/vesting/transfer-admin";
import VestingCreatedList from "components/vesting/vesting-created";

export default function AdminPage() {
  const { isAdmin, loading } = useAdmin();

  if (loading) {
    return (
      <div className="bit-container">
        <div className="bit-loading">Loading...</div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="bit-container">
        <div className="bit-error">
          <h2 className="bit-title">Access Denied</h2>
          <p className="bit-text">You do not have admin privileges</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bit-container">
      <div className="space-y-4">
        <h2 className="bit-title">Admin Dashboard</h2>
        <TransferAdmin />
        <CreateVesting />
        <VestingCreatedList />
      </div>
    </div>
  );
}
